const zhCN = {
  miniProgTitle: '访客小程序设置',

  uploadBannerTxt: '上传 Banner 图片',
  uploadBannerBtn: '上传自定义 Banner 图片',
  uploadBannerBlank: '请上传自定义 Banner 图片！',
  uploadSuccess: '上传成功！',
  uploadFail: '上传失败！',

  realNameTxt: '访客实名制',
  realNameBlank: '请选择访客实名制类型！',

  visitorMachineSettingsTitle: '访客机设置',

  departureTimeRequired: '访客申请是否必填离开时间 :',
  departureTimeRequiredDesc: '如设置为非必填，则离开时间默认为次日零点。',

  maximumAuthorizedTimeTxt: '访客最长授权时间',
  maximumAuthorizedTimeBlank: '访客最长授权时间不能为空！',
  maximumAuthorizedTimeWarning: '请填写正整数！',
  maximumAuthorizedTimUnit: '小时',

  reservedSettingsTitle: '预约设置',
  issueAccessPermissions: '预约来访人员下发门禁权限 :',

  openDoorSettingsTitle: '访客开门设置',

  openDoorTypeTxt: '访客开门方式',
  radio_IDCard: '身份证开门',
  radio_Face: '人脸验证开门',
  radio_IDCardAndFace: '身份证+人脸验证开门',

  faceValidationThresholdTxt: '访客人证验证阈值',
  faceValidationThresholdBlank: '访客最长授权时间不能为空！',
  faceValidationThresholdWarning: '请填写正整数！',
  faceValidationThresholdExcept: '访客人证验证阈值不能超过 100%！',

  submitBtn: '提交',

  getVisitorSettingsFail: '获取访客设置信息失败！',

  submitVisitorSettingsSuccess: '提交访客设置信息成功！',
  submitVisitorSettingsFail: '提交访客设置信息失败！',

  getDeviceInfoFail: '获取设备信息失败！',

  listSN: '设备SN',
  listName: '设备名称',
  listOrg: '所属机构',
  listDoorDirection: '门禁方向',
  listStatus: '设备状态',
  listOperation: '操作',

  listRemoveBtn: '移除',
  listAddBtn: '添加',
  
  signInDevicesSettings: '访客签到设备设置',
  addDeviceBtn: '添加设备',
  removeDeviceBtn: '移除设备',

  addModalTitle: '添加访客签到一体机',

  addSuccess: '添加设备成功！',
  addFail: '添加设备失败！',  

  confirmBtn: '确定',
  cancelBtn: '取消',

  removeWarning: '您确定要移除该签到设备？',
  removeWarningDesc: '移除后，该设备将不作为签到使用！',
  removeFail: '移除失败！',

  batchRemoveWarning: 'return "您确定要移除当前选中的 " + count + " 个签到设备？"',
  batchRemoveSuccess: 'return "成功移除 " + count + " 个设备！"',
  bacthRemoveFail: 'return "移除失败 " + count + " 个设备！"'
}
const enUS = {
  miniProgTitle: 'WeChat Mini-prog Settings',

  uploadBannerTxt: 'Upload Banner',
  uploadBannerBtn: 'Upload User-defined Banner',
  uploadBannerBlank: 'Please upload user-defined banner!',
  uploadSuccess: 'upload successful!',
  uploadFail: 'upload failed!',

  realNameTxt: 'Real Name',
  realNameBlank: 'Please select real name type!',

  visitorMachineSettingsTitle: 'Visitor all-in-one Machine Settings',
  
  departureTimeRequired: 'Departure time of visitor\'s application is required:',
  departureTimeRequiredDesc: 'If it is not required, the departure time defaults to zero of next day.',

  maximumAuthorizedTimeTxt: 'Maximum Authorized Time of Visitor',
  maximumAuthorizedTimeBlank: 'Maximum authorized time can\'t be blank!',
  maximumAuthorizedTimeWarning: 'Please fill in positive integers!',
  maximumAuthorizedTimUnit: 'hours',

  reservedSettingsTitle: 'Reserved Visitor Settings',
  issueAccessPermissions: 'Issue access permissions to reserved visitor :',

  openDoorSettingsTitle: 'Visitor Open Door Settings',

  openDoorTypeTxt: 'Visitor Open Door Type',
  radio_IDCard: 'ID Card',
  radio_Face: 'Face Recognition',
  radio_IDCardAndFace: 'ID Card & Face Recognition',

  faceValidationThresholdTxt: 'Face Validation Threshold',
  faceValidationThresholdBlank: 'Face validation threshold can\'t be blank!',
  faceValidationThresholdWarning: 'Please fill in positive integers!',
  faceValidationThresholdExcept: 'Face validation threshold no more than 100%!',

  submitBtn: 'Submit',

  getVisitorSettingsFail: 'Get visitor settings failed!',
  
  submitVisitorSettingsSuccess: 'Submit visitor settings successfully!',
  submitVisitorSettingsFail: 'Submit visitor settings failed!',

  getDeviceInfoFail: 'Get device information failed!',

  listSN: 'SN',
  listName: 'Name',
  listOrg: 'Organization',
  listDoorDirection: 'Direction',
  listStatus: 'Status',
  listOperation: 'Operation',

  listRemoveBtn: 'Remove',
  listAddBtn: 'Add',

  signInDevicesSettings: 'Visitor check-in device Settings',
  addDeviceBtn: 'Add Device',
  removeDeviceBtn: 'Remove Devices',

  addModalTitle: 'Add check-in device',

  addSuccess: 'Device added successfully!',
  addFail: 'Device added failed!', 
  
  confirmBtn: 'Confirm',
  cancelBtn: 'Cancel',

  removeWarning: 'Are you sure to remove this device?',
  removeWarningDesc: 'After removing the device, the visitor will lose access to the device!',
  removeFail: 'Removal failed!',

  batchRemoveWarning: 'return "Are you sure to remove the " + count + " devices?"',
  batchRemoveSuccess: 'return "Remove " + count + " devices successfully!"',
  bacthRemoveFail: 'return "Remove " + count + " devices failed!"'
}

export default { zhCN, enUS }